// components/startProject/StartDeliverables.jsx
import {
  FiCode,
  FiFileText,
  FiLayers,
  FiCloud,
  FiLifeBuoy,
} from "react-icons/fi";
import "./deliverables.css";
import { FiXCircle, FiShield, FiLock, FiKey } from "react-icons/fi";

const deliverables = [
  {
    title: "Full Source Code Ownership",
    desc: "Complete access and ownership of your application’s source code, ensuring long-term control, flexibility, and transparency.",
    icon: <FiCode />,
  },
  {
    title: "Clean, Scalable Codebase",
    desc: "Well-structured, maintainable, and documented code designed for performance, scalability, and future enhancements.",
    icon: <FiFileText />,
  },
  {
    title: "UI/UX Design System",
    desc: "Reusable UI components, layouts, and design assets used in your product for consistent future development.",
    icon: <FiLayers />,
  },
  {
    title: "Deployment & Infrastructure Setup",
    desc: "Secure deployment, environment configuration, and launch support for a stable production release.",
    icon: <FiCloud />,
  },
  {
    title: "Post-Launch Support & Optimization",
    desc: "Ongoing maintenance, monitoring, performance optimization, and technical assistance after launch.",
    icon: <FiLifeBuoy />,
  },
];

export default function StartDeliverables() {
  return (
    <section className="sp-deliverables">
      <div className="sp-deliverables-inner">
        <span className="sp-deliverables-eyebrow">Deliverables</span>

        <h2 className="sp-deliverables-title">
          What You <span>Receive</span> After Delivery
        </h2>

        <p className="sp-deliverables-intro">
          Every project with Oglitz Software is delivered with complete
          transparency, ownership, and long-term value — not just a finished
          product.
        </p>

        <div className="sp-deliverables-grid">
          {deliverables.map((item) => (
            <div key={item.title} className="sp-deliverable-card">
              <div className="sp-deliverable-top">
                <div className="sp-deliverable-icon">{item.icon}</div>
              </div>

              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="sp-trust-layout">
          {/* LEFT – What You Don’t Pay For */}
          <div className="sp-no-hidden-costs">
            <div className="sp-section-head">
              <FiXCircle />
              <h3>What You Don’t Pay For</h3>
            </div>

            <ul className="sp-no-cost-list">
              <li>No vendor lock-in or forced contracts</li>
              <li>No hidden costs or surprise charges</li>
              <li>No proprietary code restrictions</li>
              <li>No unnecessary feature upselling</li>
              <li>No dependency on paid tools without approval</li>
            </ul>
          </div>

          {/* RIGHT – Legal Trust */}
          <div className="sp-legal-trust">
            <div className="sp-trust-item">
              <FiLock />
              <div className="sp-trust-text">
                <strong>NDA Protected</strong>
                <span>Your idea & data remain confidential</span>
              </div>
            </div>

            <div className="sp-trust-item">
              <FiKey />
              <div className="sp-trust-text">
                <strong>IP Rights Included</strong>
                <span>You own the complete intellectual property</span>
              </div>
            </div>

            <div className="sp-trust-item">
              <FiShield />
              <div className="sp-trust-text">
                <strong>100% Ownership</strong>
                <span>Source code & assets belong to you</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
